import React from 'react';
import './style.css';

/**
 * HealthStatusIcon Atom
 * A pulsing indicator for system health status.
 * @param {string} status - 'online', 'warning', 'down', 'loading'
 * @param {string} className - Optional override classes
 */
const HealthStatusIcon = ({ status = 'loading', className = '' }) => {
    return (
        <span
            className={`health-status-icon ${status} ${className}`}
            aria-hidden="true"
        />
    );
};

export default HealthStatusIcon;
